import React, { Component } from "react";
import { Map, Marker, InfoWindow } from "google-maps-react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const mapStyles = {
  width: "100%",
  height: "100%"
};

export class GoogleMap extends Component {
  state = {
    activeMarker: {},
    showingInfoWindow: false
  };

  onMarkerClick = (props, marker) => {
    this.setState({
      showingInfoWindow: true,
      activeMarker: marker
    });
  };

  onMapClicked = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  };

  render() {
    const { lat, lng, locationName } = this.props;
    const google = window.google;
    return (
      <Map
        onClick={this.onMapClicked}
        google={google}
        zoom={17}
        zoomControl={false}
        style={mapStyles}
        mapTypeControl={false}
        panControl={false}
        streetViewControl={false}
        fullscreenControl={false}
        initialCenter={{
          lat: lat,
          lng: lng
        }}
      >
        <Marker position={{ lat, lng }} onClick={this.onMarkerClick} />
        <InfoWindow
          visible={this.state.showingInfoWindow}
          marker={this.state.activeMarker}
        >
          <div>
            <Typography variant="subtitle2" color="textPrimary">
              {locationName}
            </Typography>
          </div>
        </InfoWindow>
      </Map>
    );
  }
}

export default GoogleMap;

GoogleMap.propTypes = {
  google: PropTypes.any,
  lat: PropTypes.number,
  lng: PropTypes.number,
  locationName: PropTypes.string
};
